import UsersComponent from '../../components/Users/Users';

function Users() {
  return <UsersComponent />;
}

export default Users;
